import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Cookies from "js-cookie";
//i18n
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
// users
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions";
import LKUserImg from "../../../assets/images/LK_Icons/LK__User.svg";
import LKAccessImg from "../../../assets/images/LK_Icons/LK_Training.png";

import LKSettingImg from "../../../assets/images/LK_Icons/LK_Settings.svg";
import LKUnlockImg from "../../../assets/images/LK_Icons/LK_Unlock.svg";
import LKLogOutImg from "../../../assets/images/LK_Icons/LK_Log out.svg";
import arrowDown from "../../../assets/images/infobar/LK_Cheveron_Down.svg";
import AddUser from "../../../pages/Ecommerce/AddUser";
import ManageAccess from "../../../pages/Ecommerce/ManageAccess";
import ReactModal from "react-modal";
import { isTechnician } from "../../../pages/Authentication/userMetaData";
class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      isCreateAccess: false,
      isRevokeAccess: false,
      user: props.user,
    };
    this.toggle = this.toggle.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }
  componentDidMount() {
    ReactModal.setAppElement("#root");
  }

  logOut() {
    console.log("User logout success", this.props.history);

    this.props.logoutUser(this.props.history);
    // console.log("localStorage.removeItem('persist:root'): ",localStorage.getItem('persist:root'));
  }

  render() {
    let username = this.props.user?.name || "Admin";
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const uNm = obj.email.split("@")[0];
      username = obj.username;
    }

    return (
      <React.Fragment>
        {this.state.isCreateAccess && (
          <ManageAccess
            type="access"
            title="Manage Access"
            isModalOpen={this.state.isCreateAccess}
            closeModal={(isUpdated) => {
              this.setState({ isCreateAccess: false });
              // isUpdated && this.updateViewUser();
            }}
          />
        )}
        <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block user-dropdown">
          <DropdownToggle tag="button" className="btn header-item waves-effect" id="page-header-user-dropdown">
            <img className="rounded-circle header-profile-user mr-1" src={avatar2} alt="Header Avatar" />
            <span className="d-none d-xl-inline-block ml-1 mr-1 text-transform">{username}</span>
            {/* <i className="mdi mdi-chevron-down d-none ml-1 d-xl-inline-block"></i> */}
            <img src={arrowDown} alt="user" style={{ width: "14px", height: "14px" }} />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem href="#" className="d-flex align-items-center">
              {/* <i className="ri-user-line align-middle mr-1"></i>  */}
              <img src={LKUserImg} alt="user" style={styles.imgStyle} />
              {this.props.t("Profile")}
            </DropdownItem>
            {!isTechnician(this.state.user) && (
              <DropdownItem href="#" className="d-flex align-items-center" onClick={() => this.setState({ isCreateAccess: true })}>
                {/* <i className="ri-user-add-line align-middle mr-1"></i> */}
                <img src={LKAccessImg} alt="user" style={styles.imgStyle} />
                {this.props.t("Manage Access")}
              </DropdownItem>
            )}
            {/*<DropdownItem href="#"><i className="ri-wallet-2-line align-middle mr-1"></i> {this.props.t('My Wallet')}</DropdownItem>*/}
            <DropdownItem className="d-block" href="#">
              <span className="badge badge-success float-right mt-1">11</span>
              {/* <i className="ri-settings-2-line align-middle mr-1"></i> */}
              <img src={LKSettingImg} alt="setting" style={styles.imgStyle} />
              {this.props.t("Settings")}
            </DropdownItem>
            <DropdownItem href="#">
              {/* <i className="ri-lock-unlock-line align-middle mr-1"></i> */}
              <img src={LKUnlockImg} alt="unlock" style={styles.imgStyle} />
              {this.props.t("Lock screen")}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem className="text-danger" onClick={this.logOut}>
              {/* <i className="ri-shut-down-line align-middle mr-1 text-danger"></i>  */}
              <img src={LKLogOutImg} alt="logout" style={styles.imgStyle} />
              {this.props.t("Logout")}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

const styles = {
  imgStyle: { width: "16px", height: "16px", marginRight: "6px", marginBottom: "3px" },
};
const mapStatetoProps = (state) => ({
  user: state?.Login?.user,
});

export default withRouter(connect(mapStatetoProps, { logoutUser })(withNamespaces()(ProfileMenu)));
